/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { SendPaperplaneDiagIcon16Light } from './SendPaperplaneDiagIcon16Light';
import { SendPaperplaneDiagIcon16Regular } from './SendPaperplaneDiagIcon16Regular';
import { SendPaperplaneDiagIcon16Solid } from './SendPaperplaneDiagIcon16Solid';
import { SendPaperplaneDiagIcon20Light } from './SendPaperplaneDiagIcon20Light';
import { SendPaperplaneDiagIcon20Regular } from './SendPaperplaneDiagIcon20Regular';
import { SendPaperplaneDiagIcon20Solid } from './SendPaperplaneDiagIcon20Solid';
import { SendPaperplaneDiagIcon24Regular } from './SendPaperplaneDiagIcon24Regular';
import { SendPaperplaneDiagIcon24Solid } from './SendPaperplaneDiagIcon24Solid';
import { SendPaperplaneDiagIcon32Regular } from './SendPaperplaneDiagIcon32Regular';
import { SendPaperplaneDiagIcon64Regular } from './SendPaperplaneDiagIcon64Regular';
var sizes = {
    16: {
        light: SendPaperplaneDiagIcon16Light,
        regular: SendPaperplaneDiagIcon16Regular,
        solid: SendPaperplaneDiagIcon16Solid,
    },
    20: {
        light: SendPaperplaneDiagIcon20Light,
        regular: SendPaperplaneDiagIcon20Regular,
        solid: SendPaperplaneDiagIcon20Solid,
    },
    24: {
        regular: SendPaperplaneDiagIcon24Regular,
        solid: SendPaperplaneDiagIcon24Solid,
    },
    32: {
        regular: SendPaperplaneDiagIcon32Regular,
    },
    64: {
        regular: SendPaperplaneDiagIcon64Regular,
    },
};
export var SendPaperplaneDiagIcon = forwardRef('SendPaperplaneDiagIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
